/**
 * Utilitaires de formatage (monnaie, nombres)
 */

/** Formate un montant en euros avec 2 décimales : "1 234,56 €" */
export const fmtEur = (v: number): string =>
  v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

/** Formate un montant en euros sans décimales : "1 235 €" */
export const fmtEurCompact = (v: number): string =>
  new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(v) + ' €';
